import { render, staticRenderFns } from "./warranties_center.vue?vue&type=template&id=265967af&"
import script from "./warranties_center.vue?vue&type=script&lang=js&"
export * from "./warranties_center.vue?vue&type=script&lang=js&"
import style0 from "./warranties_center.vue?vue&type=style&index=0&id=265967af&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports